(() => {
  const INITIAL_VISIBLE = 5;
  const BATCH_SIZE = 10;

  window.addEventListener('load', () => {
    document.querySelectorAll('.js_show_more_news_cards').forEach((button) => {
      const targetId = button.getAttribute('aria-controls');
      if (!targetId) return;

      const container = document.querySelector('#' + targetId);
      if (!container) return;

      const allCards = Array.from(
        container.querySelectorAll(
          '.newsCardList__first-card, .newsCardList__remaining-card',
        ),
      );

      container.classList.remove('show-first-5');

      let visibleCount = INITIAL_VISIBLE;
      updateVisibility();

      button.addEventListener('click', () => {
        visibleCount = Math.min(visibleCount + BATCH_SIZE, allCards.length);
        updateVisibility();
      });

      function updateVisibility() {
        allCards.forEach((card, i) => {
          card.style.display = i < visibleCount ? '' : 'none';
        });

        if (visibleCount >= allCards.length) {
          button.classList.add('d-none');
          button.classList.remove('d-inline-flex');
          button.setAttribute('aria-expanded', 'true');
        }
      }
    });
  });
})();
